import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import ReactLoading from 'react-loading'
import { useIntl } from 'src/common/razzle-platform-translate'
import { PERIODICITY_ALL_TYPE_EXCHANGE_UUID } from 'src/configs'


const useConfirmButtonStyles = makeStyles((theme) => ({
    loadingButton: {
        marginRight: 7
    }
}))

const ConfirmButton = (props) => {
    const { onConfirm, disabled, inProgress, selectedAvailability, extraData } = props
    const classes = useConfirmButtonStyles()
    const theme = useTheme()
    const { formatMessage } = useIntl()

    const isValide =  selectedAvailability &&
        (selectedAvailability.periodicityUuid !== PERIODICITY_ALL_TYPE_EXCHANGE_UUID || typeof extraData.is_reciprocal === 'boolean')

    return (
        <Button
            onClick={() => onConfirm()}
            variant="contained"
            color="primary"
            size="small"
            disableElevation
            disableFocusRipple
            disableRipple
            disabled={disabled || !isValide}
        >
            { inProgress && <ReactLoading type={'spokes'} color={theme.palette.primary.main} height={20} width={19} className={classes.loadingButton} /> }
            <Typography >{ formatMessage({ id: 'Réserver', defaultMessage: 'Réserver' }) } </Typography>
        </Button>
    )
}

export default ConfirmButton
